<template>
    <c-dialog ref="dialog" title="客户常用地址详情" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.customer_name" class="m-detail-tag flex-center-cross">
                <label>{{detailData.customer_name}} - 常用地址</label>
            </div>
        </template>

        <module>
            <module-col>
                <c-title style="margin-top: 16px;">地址信息</c-title>
                <c-detail column="1">
                    <c-detail-item label="客户">
                        {{detailData.customer_name || '-'}}
                    </c-detail-item>
                    <c-detail-item label="省份">
                        {{detailData.province_name || '-'}}
                    </c-detail-item>
                    <c-detail-item label="城市">
                        {{detailData.city_name || '-'}}
                    </c-detail-item>
                    <c-detail-item label="区县">
                        {{detailData.county_name || '-'}}
                    </c-detail-item>
                    <c-detail-item label="地址详情" :span="2">
                        {{detailData.address_detail || '-'}}
                    </c-detail-item>
                    <c-detail-item label="启用状态">
                        <c-state dict="disableEnableDic" :value="detailData.enable_status"></c-state>
                    </c-detail-item>
                    <c-detail-item label="经度">
                        {{detailData.longitude != null ? detailData.longitude : '-'}}
                    </c-detail-item>
                    <c-detail-item label="纬度">
                        {{detailData.latitude != null ? detailData.latitude : '-'}}
                    </c-detail-item>
                    <c-detail-item label="备注" :span="2">
                        {{detailData.remark || '-'}}
                    </c-detail-item>
                    <c-detail-item label="创建人">
                        {{detailData.create_user_realname || '-'}}
                    </c-detail-item>
                    <c-detail-item label="创建时间">
                        {{detailData.create_date || '-'}}
                    </c-detail-item>
                </c-detail>
            </module-col>
        </module>
    </c-dialog>
</template>

<script>
export default {
    name: 'customerAddressDetail',

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {}
        }
    },

    methods: {
        open() {
            this.request({
                url: '/customer/address/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data;
                    this.$refs.dialog.open();
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
